export default __webpack_public_path__ + "static/media/logo-yellow.b6abd9fe.png";